import {Component, inject, OnDestroy} from '@angular/core';
import {DataService} from "../../service/data.service";
import {CanActivateFn, Router} from "@angular/router";
import {Subscription} from "rxjs";
import {ProgressService} from "../../service/progress.service";
import {Toast, ToastModule} from 'primeng/toast';
import {BlockUI, BlockUIModule} from 'primeng/blockui';
import {ProgressSpinner, ProgressSpinnerModule} from 'primeng/progressspinner';
import { AsyncPipe, CommonModule } from '@angular/common';
import {FormsModule} from "@angular/forms";
import {ChartModule} from "primeng/chart";
import {MenuModule} from "primeng/menu";
import {TableModule} from "primeng/table";
import {StyleClassModule} from "primeng/styleclass";
import {PanelMenuModule} from "primeng/panelmenu";
import {ButtonModule} from "primeng/button";

@Component({
    templateUrl: './loading-page.component.html',
    imports: [
        Toast,
        BlockUI,
        ProgressSpinner,
        AsyncPipe,
        CommonModule,
        FormsModule,
        ChartModule,
        MenuModule,
        TableModule,
        StyleClassModule,
        PanelMenuModule,
        ButtonModule,
        ToastModule,
        BlockUIModule,
        ProgressSpinnerModule
    ],
    standalone: true
})
export class LoadingPageComponent implements OnDestroy {
    protected progressService = inject(ProgressService);
    private dataService = inject(DataService);

    constructor() {
        const progressService = this.progressService;
        const dataService = this.dataService;

        progressService.blockWithMessage('Loading . . .');
        this.subscriptions.push(dataService.userObs.subscribe(u => {
            progressService.unBlock();
            this.dataService.redirectToHome(true);
        }));
    }

    private subscriptions: Subscription[] = [];
    ngOnDestroy() {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe())
    }
}

export const initialLoadingGuard: CanActivateFn = (route, state) => {
    // console.log("Running Initial loading check");
    const dataService = inject(DataService);
    if (dataService.started()) {
        return true;
    } else {
        dataService.redirectUrl=state.url;
        dataService.getOrCreatePlatformUser();
        return inject(Router).parseUrl("/loading");
    }
};
